<template>
    <div class="notification-email">
        <CompassObject size="small" type="object" object="inbox-email" />
        <div>
            <div class="typographies-paragraph-medium-bold">
                {{ getText.label }}
            </div>
            <div class="typographies-paragraph-medium-regular">
                {{ getText.subject }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotificationEmail',
    props: {
        type: {
            type: String,
            required: true,
        },
        notification: {
            type: Object,
            required: true,
        },
    },
    computed: {
        getSenderEmail() {
            return this.type === 'banner'
                ? this.notification.sender_email
                : this.notification.event_details.sender_email;
        },
        getSubject() {
            return this.type === 'banner'
                ? this.notification.subject
                : this.notification.event_details.subject;
        },
        getText() {
            const text = {
                label: this.$t.__(`email.NotificationEmailItem.label_email`, {
                    emailAddress: this.getSenderEmail,
                }),
                subject: this.getSubject,
            };
            return text;
        },
    },
};
</script>

<style lang="scss" scoped>
.notification-email {
    display: flex;
    align-items: center;
    gap: var(--spacing-1);
}
</style>
